import { render, staticRenderFns } from "./RegisterAuthForm.vue?vue&type=template&id=f9f24bf8"
import script from "./RegisterAuthForm.vue?vue&type=script&lang=js"
export * from "./RegisterAuthForm.vue?vue&type=script&lang=js"
import style0 from "./RegisterAuthForm.vue?vue&type=style&index=0&id=f9f24bf8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports